import { Grid, Typography, colors } from '@material-ui/core';
import { Label } from 'components';
import { applicationContext } from 'helpers/services';
import { useContext } from 'react';
import { excelImportContext } from '../ExcelImportContext';


let Content = () => {
    let { referenceData } = useContext(applicationContext);
    let { excelImport } = useContext(excelImportContext);

    return (
        <Grid container spacing={2}>
            <Grid item xs>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <Typography variant="h5">Status</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>
                            {excelImport.status.hasErrors
                                ? <Label color={colors.red[500]}>Invalid</Label>
                                : <Label color={colors.green[500]}>Valid</Label>
                            }
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3} >
                    <Grid item xs={3}>
                        <Typography variant="h5">Info</Typography>
                    </Grid>
                    <Grid item xs>
                        {excelImport.status.info.length === 0 && <Typography>-</Typography>}
                        {excelImport.status.info.map(info => <Typography key={info}>{info}</Typography>)}
                    </Grid>
                </Grid>
                <Grid container spacing={3} >
                    <Grid item xs={3}>
                        <Typography variant="h5">Errors</Typography>
                    </Grid>
                    <Grid item xs>
                        {excelImport.status.errors.length === 0 && <Typography>-</Typography>}
                        {excelImport.status.errors.map(error => <Typography key={error}>{error}</Typography>)}
                    </Grid>
                </Grid>
                <Grid container spacing={3} >
                    <Grid item xs={3}>
                        <Typography variant="h5">Warnings</Typography>
                    </Grid>
                    <Grid item xs>
                        {excelImport.status.warnings.length === 0 && <Typography>-</Typography>}
                        {excelImport.status.warnings.map(warning => <Typography key={warning}>{warning}</Typography>)}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography variant="h5">Filename</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{excelImport.status.fileName}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography variant="h5">Country</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{referenceData.countries.getValueByKey(excelImport.countryCode)}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography variant="h5">Dealers that will be added</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{excelImport.status.dealersToAdd}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography variant="h5">Dealers that will be updated</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{excelImport.status.dealersToUpdate}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography variant="h5">Valid Columns</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{excelImport.status.validColumns}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={4}>
                        <Typography variant="h5">Invalid Columns</Typography>
                    </Grid>
                    <Grid item xs>
                        <Typography>{excelImport.status.invalidColumns}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Content;